import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Domain, DomainUpdate } from './domain.model';

const BASE = environment.contractUrl;

/** CRUD for the global DOMAINS table (domain → default brand / sub-brand). */
@Injectable({ providedIn: 'root' })
export class DomainService {
  private readonly http = inject(HttpClient);

  listDomains(): Observable<Domain[]> {
    return this.http.get<Domain[]>(`${BASE}/domains`);
  }

  createDomain(domain: Domain): Observable<Domain> {
    return this.http.post<Domain>(`${BASE}/domains`, domain);
  }

  updateDomain(domain: string, payload: DomainUpdate): Observable<Domain> {
    return this.http.put<Domain>(`${BASE}/domains/${encodeURIComponent(domain)}`, payload);
  }

  deleteDomain(domain: string): Observable<void> {
    return this.http.delete<void>(`${BASE}/domains/${encodeURIComponent(domain)}`);
  }
}
